<template>
  <nav class="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700 fixed-header">
    <div class="w-full px-4 sm:px-6 lg:px-8">
      <!-- 移动端汉堡菜单 -->
      <div class="lg:hidden">
        <div class="flex justify-between items-center h-16">
          <div class="flex items-center">
            <div class="flex items-center cursor-pointer" @click="goHome">
              <i class="fas fa-broadcast-tower text-purple-600 text-2xl mr-2"></i>
              <span class="text-xl font-bold text-gray-800 dark:text-gray-200">{{ $store.getters.t('platformname') }}</span>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <!-- 移动端汉堡菜单按钮 -->
            <button 
              @click="toggleMobileMenu"
              class="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-500"
            >
              <i class="fas fa-bars text-lg"></i>
            </button>
          </div>
        </div>
        
        <!-- 移动端菜单 -->
        <div 
          v-show="isMobileMenuOpen"
          class="lg:hidden bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-2"
        >
          <!-- 移动端导航菜单 -->
          <div class="space-y-1 px-2 pb-3">
            <!-- 首页 -->
            <router-link 
              to="/" 
              class="text-gray-600 hover:text-purple-600 block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200"
              active-class="text-purple-600 bg-purple-50"
              @click="closeMobileMenu"
            >
              <i class="fas fa-tachometer-alt mr-2"></i>
              {{ $store.getters.t('dashboard') }}
            </router-link>
            
            <!-- 移动端子菜单项 -->
            <div v-for="menu in mobileMenuItems" :key="menu.key">
              <button 
                @click="toggleMobileSubmenu(menu.key)"
                class="text-gray-600 hover:text-purple-600 w-full text-left px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 flex items-center justify-between"
                :class="{ 'text-purple-600 bg-purple-50': activeMobileSubmenu === menu.key }"
              >
                <span>
                  <i :class="menu.icon + ' mr-2'"></i>
                  {{ menu.title }}
                </span>
                <i :class="activeMobileSubmenu === menu.key ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" class="text-xs"></i>
              </button>
              
              <div v-show="activeMobileSubmenu === menu.key" class="ml-4 space-y-1 mt-1">
                <router-link 
                  v-for="item in menu.items" 
                  :key="item.path"
                  :to="item.path" 
                  class="text-gray-600 hover:text-purple-600 block px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
                  @click="closeMobileMenu"
                >
                  <i :class="item.icon + ' mr-2'"></i>
                  {{ item.title }}
                </router-link>
              </div>
            </div>
          </div>
          
          <!-- 移动端用户操作区域 -->
          <div class="border-t border-gray-200 pt-4 pb-3">
            <div class="flex items-center px-5">
              <div class="flex-shrink-0">
                <img class="h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="用户头像">
              </div>
              <div class="ml-3">
                <div class="text-base font-medium text-gray-800">{{ $store.state.user.name }}</div>
              </div>
            </div>
            <div class="mt-3 space-y-1 px-2">
              <!-- 语言切换 -->
              <select 
                v-model="currentLang" 
                @change="changeLanguage"
                class="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-purple-500 bg-white mt-2"
              >
                <option value="zh">中文</option>
                <option value="en">English</option>
                <option value="ja">日本語</option>
              </select>
              
              <button class="text-gray-600 hover:text-gray-800 w-full text-left px-3 py-2 rounded-md text-base font-medium">
                <i class="fas fa-bell mr-2"></i>
                通知
              </button>
              <button 
                @click="openSettings"
                class="text-gray-600 hover:text-gray-800 w-full text-left px-3 py-2 rounded-md text-base font-medium"
              >
                <i class="fas fa-cog mr-2"></i>
                设置
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 桌面端布局 -->
      <div class="hidden lg:flex lg:items-center lg:h-16">
        <div class="flex items-center">
          <div class="flex items-center cursor-pointer" @click="goHome">
            <i class="fas fa-broadcast-tower text-purple-600 text-2xl mr-2"></i>
            <span class="text-xl font-bold text-gray-800 dark:text-gray-200">{{ $store.getters.t('platformname') }}</span>
          </div>
        </div>
        
        <!-- 桌面端导航菜单 -->
        <div class="hidden lg:flex lg:items-center lg:space-x-6 lg:ml-6">
          <router-link 
            to="/" 
            class="text-gray-600 hover:text-purple-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
            active-class="text-purple-600 bg-purple-50"
          >
            <i class="fas fa-tachometer-alt mr-2"></i>
            {{ $store.getters.t('dashboard') }}
          </router-link>
          <!-- 总智能体 -->
          <div class="relative group">
              <button 
                @click="goToAgentChat"
                @mouseenter="toggleSubmenu('head')"
                class="text-gray-600 hover:text-purple-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 flex items-center"
                :class="{ 'text-purple-600 bg-purple-50': $route.path === '/agent-chat' || $route.path === '/head-agent' || $route.path === '/head-flow' }"
              >
                <i class="fas fa-brain mr-2"></i>
                {{ $store.getters.t('menu_head_agent') }}
                <i class="fas fa-chevron-down ml-1 text-xs"></i>
              </button>
              <div 
                v-show="activeSubmenu === 'head'"
                class="absolute top-full left-0 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-lg z-50 min-w-48"
                @mouseenter="activeSubmenu = 'head'"
                @mouseleave="activeSubmenu = null"
              >
                <router-link 
                  to="/agent-chat" 
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-comments mr-2"></i>
                  {{ $store.getters.t('menu_agent_chat') }}
                </router-link>
                <router-link 
                  to="/head-agent" 
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-brain mr-2"></i>
                  {{ $store.getters.t('menu_head_agent') }}
                </router-link>
                <router-link 
                  to="/head-flow" 
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-stream mr-2"></i>
                  {{ $store.getters.t('menu_head_flow') }}
                </router-link>
              </div>
          </div>
          
          <!-- 招聘智能体 -->
          <div v-if="hasRole('HR') || isAdmin" class="relative group">
              <button 
                @click="goToRecruitmentAgent"
                @mouseenter="toggleSubmenu('recruitment')"
                class="text-gray-600 hover:text-purple-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 flex items-center"
                :class="{ 'text-purple-600 bg-purple-50': $route.path === '/recruitment-agent' }"
              >
                <i class="fas fa-user-plus mr-2"></i>
                {{ $store.getters.t('menu_recruitment_agent') }}
                <i class="fas fa-chevron-down ml-1 text-xs"></i>
              </button>
              <div 
                v-show="activeSubmenu === 'recruitment'"
                class="absolute top-full left-0 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-lg z-50 min-w-48"
                @mouseenter="activeSubmenu = 'recruitment'"
                @mouseleave="activeSubmenu = null"
              >
                <router-link 
                  to="/recruitment-agent" 
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-user-plus mr-2"></i>
                  {{ $store.getters.t('menu_recruitment_management') }}
                </router-link>
                <a 
                  href="http://cv.withflows.com/admin" 
                  target="_blank"
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-external-link-alt mr-2"></i>
                  {{ $store.getters.t('menu_external_system') }}
                </a>
              </div>
          </div>
          
          <!-- 建联经纪人角色菜单 -->
          <template v-if="hasRole('Recuriting') || isAdmin">
            <!-- 建联智能体 -->
            <div class="relative group">
              <button 
                @click="toggleSubmenu('connect')"
                class="text-gray-600 hover:text-purple-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 flex items-center"
                :class="{ 'text-purple-600 bg-purple-50': activeSubmenu === 'connect' }"
              >
                <i class="fas fa-link mr-2"></i>
                {{ $store.getters.t('menu_connect_agent') }}
                <i class="fas fa-chevron-down ml-1 text-xs"></i>
              </button>
              <div 
                v-show="activeSubmenu === 'connect'"
                class="absolute top-full left-0 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-lg z-50 min-w-48"
                @mouseenter="activeSubmenu = 'connect'"
                @mouseleave="activeSubmenu = null"
              >
                <router-link 
                  to="/creator-lead" 
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-desktop mr-2"></i>
                  {{ $store.getters.t('menu_connect_workbench') }}
                </router-link>
                <router-link 
                  to="/connect-agent" 
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-stream mr-2"></i>
                  {{ $store.getters.t('menu_connect_flow') }}
                </router-link>
              </div>
            </div>
          </template>
          <template v-if="hasRole('Creator') || isAdmin">
            <!-- 主播智能体 -->
            <div class="relative group">
              <button 
                @click="toggleSubmenu('streamer')"
                class="text-gray-600 hover:text-purple-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 flex items-center"
                :class="{ 'text-purple-600 bg-purple-50': activeSubmenu === 'streamer' }"
              >
                <i class="fas fa-user-tie mr-2"></i>
                {{ $store.getters.t('menu_streamer_agent') }}
                <i class="fas fa-chevron-down ml-1 text-xs"></i>
              </button>
              <div 
                v-show="activeSubmenu === 'streamer'"
                class="absolute top-full left-0 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-lg z-50 min-w-48"
                @mouseenter="activeSubmenu = 'streamer'"
                @mouseleave="activeSubmenu = null"
              >
                <router-link 
                  to="/streamer-workbench" 
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-desktop mr-2"></i>
                  {{ $store.getters.t('menu_streamer_workbench') }}
                </router-link>
                <router-link 
                  to="/streamer-agent" 
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-stream mr-2"></i>
                  {{ $store.getters.t('menu_streamer_flow') }}
                </router-link>
              </div>
            </div>
            
          </template>
          <template v-if="hasRole('Operation') || isAdmin">
            <!-- 运营智能体 -->
            <div class="relative group">
              <button 
                @click="toggleSubmenu('operation')"
                class="text-gray-600 hover:text-purple-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 flex items-center"
                :class="{ 'text-purple-600 bg-purple-50': activeSubmenu === 'operation' }"
              >
                <i class="fas fa-cogs mr-2"></i>
                {{ $store.getters.t('menu_operation_agent') }}
                <i class="fas fa-chevron-down ml-1 text-xs"></i>
              </button>
              <div 
                v-show="activeSubmenu === 'operation'"
                class="absolute top-full left-0 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-lg z-50 min-w-48"
                @mouseenter="activeSubmenu = 'operation'"
                @mouseleave="activeSubmenu = null"
              >
                <router-link 
                  to="/operation-workbench" 
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-desktop mr-2"></i>
                  {{ $store.getters.t('menu_operation_workbench') }}
                </router-link>
                <router-link 
                  to="/operation-agent" 
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-stream mr-2"></i>
                  {{ $store.getters.t('menu_operation_flow') }}
                </router-link>
              </div>
            </div>
            
          </template>
          <template v-if="hasRole('VideoProducer') || isAdmin">
            <!-- 视频师智能体 -->
            <div class="relative group">
              <button 
                @click="toggleSubmenu('video')"
                class="text-gray-600 hover:text-purple-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 flex items-center"
                :class="{ 'text-purple-600 bg-purple-50': activeSubmenu === 'video' }"
              >
                <i class="fas fa-video mr-2"></i>
                {{ $store.getters.t('menu_publish_agent') }}
                <i class="fas fa-chevron-down ml-1 text-xs"></i>
              </button>
              <div 
                v-show="activeSubmenu === 'video'"
                class="absolute top-full left-0 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-lg z-50 min-w-48"
                @mouseenter="activeSubmenu = 'video'"
                @mouseleave="activeSubmenu = null"
              >
                <router-link 
                  to="/video-workbench" 
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-desktop mr-2"></i>
                  {{ $store.getters.t('menu_publish_workbench') }}
                </router-link>
                <router-link 
                  to="/publish-agent" 
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-100 dark:hover:bg-gray-700 hover:text-purple-600 dark:hover:text-purple-300"
                >
                  <i class="fas fa-stream mr-2"></i>
                  {{ $store.getters.t('menu_publish_flow') }}
                </router-link>
              </div>
            </div>
          </template>
          
          <!-- 其他角色的菜单可以在这里添加 -->
        </div>
        
        <!-- 桌面端用户操作区域 -->
        <div class="hidden lg:flex lg:items-center lg:space-x-4 lg:ml-auto">
          <!-- 平台切换 -->
           <!-- 
          <select  
            v-model="currentPlatform" 
            @change="changePlatform"
            class="border rounded-lg px-2 py-1 text-sm focus:outline-none focus:border-indigo-500"
            title="平台切换"
          >
            <option value="抖音">抖音</option>
            <option value="快手">快手</option>
            <option value="视频号">视频号</option>
            <option value="TT">TT</option>
            <option value="Youtube">Youtube</option>
            <option value="Ins">Ins</option>
          </select>
          -->
          <button class="text-gray-600 hover:text-gray-800">
            <i class="fas fa-bell"></i>
          </button>
          <button 
            @click="openSettings"
            class="text-gray-600 hover:text-gray-800"
          >
            <i class="fas fa-cog"></i>
          </button>
          
          <div class="flex items-center">
            <img class="h-8 w-8 rounded-full cursor-pointer hover:ring-2 hover:ring-purple-500 transition-all" :src="$store.state.user.avatar" :alt="$store.state.user.name" :title="$store.state.user.name">
          </div>
          
          <select 
            v-model="currentLang" 
            @change="changeLanguage"
            class="border rounded-lg px-2 py-1 text-sm focus:outline-none focus:border-indigo-500"
          >
            <option value="zh">中文</option>
            <option value="en">English</option>
            <option value="ja">日本語</option>
          </select>
        </div>
      </div>
      
      <!-- 设置面板 -->
      <div 
        v-show="isSettingsOpen"
        class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
        @click="closeSettings"
      >
        <div 
          class="bg-white rounded-lg shadow-xl max-w-md w-full max-h-96 overflow-y-auto"
          @click.stop
        >
          <div class="px-6 py-4 border-b border-gray-200">
            <h3 class="text-lg font-medium text-gray-900">设置</h3>
          </div>
          
          <div class="px-6 py-4 space-y-4">
            <!-- 主题设置 -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">显示模式</label>
              <div class="space-y-2">
                <div class="flex items-center">
                  <input 
                    type="radio" 
                    id="theme-system" 
                    v-model="currentTheme" 
                    value="system"
                    class="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300"
                    @change="changeTheme"
                  >
                  <label for="theme-system" class="ml-3 block text-sm font-medium text-gray-700">
                    <i class="fas fa-adjust mr-2"></i>
                    跟随系统
                  </label>
                </div>
                <div class="flex items-center">
                  <input 
                    type="radio" 
                    id="theme-light" 
                    v-model="currentTheme" 
                    value="light"
                    class="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300"
                    @change="changeTheme"
                  >
                  <label for="theme-light" class="ml-3 block text-sm font-medium text-gray-700">
                    <i class="fas fa-sun mr-2"></i>
                    浅色模式
                  </label>
                </div>
                <div class="flex items-center">
                  <input 
                    type="radio" 
                    id="theme-dark" 
                    v-model="currentTheme" 
                    value="dark"
                    class="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300"
                    @change="changeTheme"
                  >
                  <label for="theme-dark" class="ml-3 block text-sm font-medium text-gray-700">
                    <i class="fas fa-moon mr-2"></i>
                    深色模式
                  </label>
                </div>
              </div>
            </div>
            
            <!-- 其他设置项可以在这里添加 -->
            <div class="border-t border-gray-200 pt-4">
              <p class="text-sm text-gray-500">更多设置选项将在后续版本中添加</p>
            </div>
          </div>
          
          <div class="px-6 py-4 border-t border-gray-200 bg-gray-50 rounded-b-lg">
            <button 
              @click="closeSettings"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-purple-600 text-base font-medium text-white hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 sm:text-sm"
            >
              关闭
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import authService from '@/services/authService'

export default {
  name: 'AppHeader',
  data() {
    return {
      activeSubmenu: 'head', // 当前激活的子菜单
      isMobileMenuOpen: false, // 移动端菜单是否打开
      activeMobileSubmenu: null, // 当前激活的移动端子菜单
      currentTheme: 'system', // 当前主题：system, light, dark
      isSettingsOpen: false, // 设置面板是否打开
      isLoadingRoles: false // 是否正在加载角色列表
    }
  },
  computed: {
    mobileMenuItems() {
      const baseMenus = [
        {
          key: 'head',
          title: this.$store.getters.t('menu_head_agent'),
          icon: 'fas fa-brain',
          items: [
            { path: '/agent-chat', title: this.$store.getters.t('menu_agent_chat'), icon: 'fas fa-comments' },
            { path: '/head-agent', title: this.$store.getters.t('menu_head_agent'), icon: 'fas fa-brain' },
            { path: '/head-flow', title: this.$store.getters.t('menu_head_flow'), icon: 'fas fa-stream' }
          ]
        }
      ];

      // 根据用户角色添加对应的菜单
      const roleMenus = {
        'HR': {
          key: 'recruitment',
          title: this.$store.getters.t('menu_recruitment_agent'),
          icon: 'fas fa-user-plus',
          items: [
            { path: '/recruitment-agent', title: this.$store.getters.t('menu_recruitment_management'), icon: 'fas fa-user-plus' }
          ]
        },
        'Recuriting': {
          key: 'connect',
          title: this.$store.getters.t('menu_connect_agent'),
          icon: 'fas fa-link',
          items: [
            { path: '/creator-lead', title: this.$store.getters.t('menu_connect_workbench'), icon: 'fas fa-desktop' },
            { path: '/connect-agent', title: this.$store.getters.t('menu_connect_flow'), icon: 'fas fa-stream' }
          ]
        },
        'Creator': {
          key: 'streamer',
          title: this.$store.getters.t('menu_streamer_agent'),
          icon: 'fas fa-user-tie',
          items: [
            { path: '/streamer-workbench', title: this.$store.getters.t('menu_streamer_workbench'), icon: 'fas fa-desktop' },
            { path: '/streamer-agent', title: this.$store.getters.t('menu_streamer_flow'), icon: 'fas fa-stream' }
          ]
        },
        'Operation': {
          key: 'operation',
          title: this.$store.getters.t('menu_operation_agent'),
          icon: 'fas fa-cogs',
          items: [
            { path: '/operation-workbench', title: this.$store.getters.t('menu_operation_workbench'), icon: 'fas fa-desktop' },
            { path: '/operation-agent', title: this.$store.getters.t('menu_operation_flow'), icon: 'fas fa-stream' }
          ]
        },
        'VideoProducer': {
          key: 'video',
          title: this.$store.getters.t('menu_publish_agent'),
          icon: 'fas fa-video',
          items: [
            { path: '/video-workbench', title: this.$store.getters.t('menu_publish_workbench'), icon: 'fas fa-desktop' },
            { path: '/publish-agent', title: this.$store.getters.t('menu_publish_flow'), icon: 'fas fa-stream' }
          ]
        }
      };

      // 如果是管理员，添加所有菜单
      if (this.isAdmin) {
        Object.values(roleMenus).forEach(menu => {
          baseMenus.push(menu);
        });
      } else {
        // 根据用户拥有的角色添加菜单
        this.availableRoleCodes.forEach(roleCode => {
          if (roleMenus[roleCode]) {
            baseMenus.push(roleMenus[roleCode]);
          }
        });
      }

      return baseMenus;
    },
    currentPlatform: {
      get() {
        return this.$store.state.currentPlatform
      },
      set(value) {
        this.$store.commit('setCurrentPlatform', value)
      }
    },
    currentRole: {
      get() {
        return this.$store.state.currentRole
      },
      set(value) {
        this.$store.commit('setCurrentRole', value)
      }
    },
    currentLang: {
      get() {
        return this.$store.state.currentLang
      },
      set(value) {
        this.$store.commit('setCurrentLang', value)
      }
    },
    // 从store获取可用角色代码列表
    availableRoleCodes() {
      return this.$store.state.availableRoles || []
    },
    // 判断是否是管理员
    isAdmin() {
      return this.availableRoleCodes.includes('Admin')
    }
  },
  methods: {
    goHome() {
      this.$router.push('/')
    },
    changePlatform(event) {
      const platform = event.target.value
      this.$store.commit('setCurrentPlatform', platform)
      
      // 显示切换提示
      this.showNotification(`平台已切换到: ${this.getPlatformText(platform)}`)
      
      // 这里可以添加平台切换后的其他逻辑
      console.log('平台切换:', platform)
    },
    
    // 角色切换功能已移除，不再需要此方法
    // changeRole方法保留用于兼容性，但不执行任何操作
    
    changeLanguage(event) {
      const lang = event.target.value
      this.$store.commit('setCurrentLang', lang)
      
      // 显示切换提示
      this.showNotification(`语言已切换到: ${this.getLanguageText(lang)}`)
      
      // 这里可以添加语言切换后的其他逻辑
      console.log('语言切换:', lang)
    },
    
    getPlatformText(platform) {
      const platformMap = {
        '抖音': '抖音',
        '快手': '快手',
        '视频号': '视频号',
        'TT': 'TT',
        'Youtube': 'Youtube',
        'Ins': 'Ins'
      }
      return platformMap[platform] || platform
    },
    
    getRoleText(role) {
      const roleMap = {
        'connect-agent': '建联经纪人',
        'streamer-agent': '主播',
        'operation-agent': '运营经纪人',
        'publish-agent': '视频发布师'
      }
      return roleMap[role] || role
    },
    
    getLanguageText(lang) {
      const langMap = {
        'zh': '中文',
        'en': 'English',
        'ja': '日本語'
      }
      return langMap[lang] || lang
    },
    
    showNotification(message) {
      // 创建通知元素
      const notification = document.createElement('div')
      notification.className = 'fixed top-20 right-4 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg z-50 transform transition-all duration-300 translate-x-full'
      notification.textContent = message
      
      // 添加到页面
      document.body.appendChild(notification)
      
      // 显示动画
      setTimeout(() => {
        notification.classList.remove('translate-x-full')
      }, 100)
      
      // 自动隐藏
      setTimeout(() => {
        notification.classList.add('translate-x-full')
        setTimeout(() => {
          document.body.removeChild(notification)
        }, 300)
      }, 3000)
    },

    toggleSubmenu(submenu) {
      this.activeSubmenu = this.activeSubmenu === submenu ? null : submenu
    },
    
    goToAgentChat() {
      this.$router.push('/agent-chat')
    },
    
    goToRecruitmentAgent() {
      this.$router.push('/recruitment-agent')
    },

    // 移动端菜单相关方法
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
      if (!this.isMobileMenuOpen) {
        this.activeMobileSubmenu = null
      }
    },

    closeMobileMenu() {
      this.isMobileMenuOpen = false
      this.activeMobileSubmenu = null
    },

    toggleMobileSubmenu(submenu) {
      this.activeMobileSubmenu = this.activeMobileSubmenu === submenu ? null : submenu
    },

    handleClickOutside(event) {
      const submenu = document.querySelector('.absolute.top-full.left-0.mt-0.bg-white.border.border-gray-200.rounded-md.shadow-lg.z-50.min-w-48')
      if (submenu && !submenu.contains(event.target) && !this.$el.contains(event.target)) {
        this.activeSubmenu = null
      }
    },
    
    updateHeaderOffset() {
      const header = document.querySelector('.fixed-header')
      if (header) {
        const headerHeight = header.offsetHeight
        // 设置CSS变量，供内容区域使用
        document.documentElement.style.setProperty('--header-height', `${headerHeight + 20}px`)
        console.log('页头高度:', headerHeight, '设置偏移:', headerHeight + 20)
      }
    },

    // 主题切换相关方法
    toggleTheme() {
      const themes = ['system', 'light', 'dark']
      const currentIndex = themes.indexOf(this.currentTheme)
      const nextIndex = (currentIndex + 1) % themes.length
      this.currentTheme = themes[nextIndex]
      this.applyTheme()
      this.showNotification(`主题已切换到: ${this.getThemeText(this.currentTheme)}`)
    },

    changeTheme(event) {
      this.currentTheme = event.target.value
      this.applyTheme()
      this.showNotification(`主题已切换到: ${this.getThemeText(this.currentTheme)}`)
    },

    applyTheme() {
      // 移除现有的主题类
      document.documentElement.classList.remove('theme-light', 'theme-dark', 'theme-system')
      
      // 根据当前主题设置类
      if (this.currentTheme === 'light') {
        document.documentElement.classList.add('theme-light')
      } else if (this.currentTheme === 'dark') {
        document.documentElement.classList.add('theme-dark')
      } else {
        document.documentElement.classList.add('theme-system')
      }
      
      // 保存主题偏好到 localStorage
      localStorage.setItem('theme', this.currentTheme)
    },

    getThemeText(theme) {
      const themeMap = {
        'system': '跟随系统',
        'light': '浅色模式',
        'dark': '深色模式'
      }
      return themeMap[theme] || theme
    },

    getThemeIcon(theme) {
      const iconMap = {
        'system': 'fas fa-adjust',
        'light': 'fas fa-sun',
        'dark': 'fas fa-moon'
      }
      return iconMap[theme] || 'fas fa-adjust'
    },

    loadTheme() {
      // 从 localStorage 加载保存的主题
      const savedTheme = localStorage.getItem('theme')
      if (savedTheme) {
        this.currentTheme = savedTheme
      } else {
        // 如果没有保存的主题，使用系统偏好
        this.currentTheme = 'system'
      }
      this.applyTheme()
    },

    // 设置面板相关方法
    openSettings() {
      this.isSettingsOpen = true
    },

    closeSettings() {
      this.isSettingsOpen = false
    },
    
    /**
     * 加载角色列表
     */
    async loadRoles() {
      try {
        this.isLoadingRoles = true
        const roles = await authService.getRole()
        // 将角色列表存储到store
        this.$store.dispatch('setAvailableRoles', roles)
        
        // 根据第一个可用角色设置默认角色（用于兼容性）
        if (roles.length > 0 && !this.isAdmin) {
          const firstRoleValue = this.getRoleValue(roles[0])
          if (firstRoleValue) {
            this.$store.commit('setCurrentRole', firstRoleValue)
          }
        } else if (this.isAdmin) {
          // 管理员默认设置为第一个角色
          const allRoles = ['Recuriting', 'Creator', 'Operation', 'VideoProducer', 'HR']
          const firstRoleValue = this.getRoleValue(allRoles[0])
          if (firstRoleValue) {
            this.$store.commit('setCurrentRole', firstRoleValue)
          }
        }
      } catch (error) {
        console.error('加载角色列表失败:', error)
      } finally {
        this.isLoadingRoles = false
      }
    },
    
    /**
     * 根据角色代码获取内部角色值
     * @param {string} roleCode 角色代码（如 'Recuriting', 'Creator' 等）
     * @returns {string} 内部角色值（如 'connect-agent', 'streamer-agent' 等）
     */
    getRoleValue(roleCode) {
      return this.$store.state.roleCodeMapping[roleCode] || ''
    },
    
    /**
     * 根据角色代码获取显示名称
     * @param {string} roleCode 角色代码
     * @returns {string} 显示名称
     */
    getRoleName(roleCode) {
      return this.$store.state.roleNameMapping[roleCode] || roleCode
    },
    
    /**
     * 获取当前角色的角色代码
     * @returns {string|null} 角色代码
     */
    getCurrentRoleCode() {
      const currentRole = this.currentRole
      const mapping = this.$store.state.roleCodeMapping
      for (const [code, value] of Object.entries(mapping)) {
        if (value === currentRole) {
          return code
        }
      }
      return null
    },
    
    /**
     * 判断用户是否有指定角色
     * @param {string} roleCode 角色代码
     * @returns {boolean} 是否有该角色
     */
    hasRole(roleCode) {
      // 如果是管理员，返回true
      if (this.isAdmin) {
        return true
      }
      // 检查用户是否拥有该角色
      return this.availableRoleCodes.includes(roleCode)
    }
  },
  mounted() {
    // 添加点击外部关闭子菜单的监听器
    document.addEventListener('click', this.handleClickOutside)
    
    // 动态计算页头高度并设置内容偏移
    this.$nextTick(() => {
      this.updateHeaderOffset()
    })
    
    // 监听窗口大小变化，重新计算偏移
    window.addEventListener('resize', this.updateHeaderOffset)
    
    // 加载主题设置
    this.loadTheme()
    
    // 加载角色列表
    this.loadRoles()
  },
  beforeDestroy() {
    // 移除监听器
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('resize', this.updateHeaderOffset)
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  opacity: 0.8;
}

/* 固定页头样式 */
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}


/* 为固定页头添加内容偏移 */
.header-offset {
  padding-top: 120px; /* 基础偏移，将通过JavaScript动态调整 */
}

/* 动态调整内容偏移 */
.header-offset-dynamic {
  padding-top: var(--header-height, 120px);
}

/* 导航菜单样式 */
.border-t {
  border-top-width: 1px;
}

.border-gray-200 {
  border-color: #e5e7eb;
}

.border-gray-100 {
  border-color: #f3f4f6;
}

.flex-wrap {
  flex-wrap: wrap;
}

.gap-2 {
  gap: 0.5rem;
}

.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
}

.duration-200 {
  transition-duration: 200ms;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

/* 子菜单样式 */
.absolute {
  position: absolute;
}

.top-full {
  top: 100%;
}

.left-0 {
  left: 0;
}

.mt-1 {
  margin-top: 0.25rem;
}

.bg-white {
  background-color: #ffffff;
}

.border {
  border-width: 1px;
}

.border-gray-200 {
  border-color: #e5e7eb;
}

.rounded-md {
  border-radius: 0.375rem;
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.z-50 {
  z-index: 50;
}

.min-w-48 {
  min-width: 12rem;
}

/* 子菜单动画 */
.group:hover .absolute {
  opacity: 1;
  transform: translateY(0);
}

.absolute {
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.2s ease-in-out;
}

.absolute[v-show="true"] {
  opacity: 1;
  transform: translateY(0);
}

/* 响应式设计 */
/* 移动端样式 */
@media (max-width: 1023px) {
  .fixed-header {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  /* 移动端菜单动画 */
  .lg\\:hidden[v-show="true"] {
    animation: slideDown 0.3s ease-out;
  }
  
  /* 移动端子菜单动画 */
  .ml-4[v-show="true"] {
    animation: fadeIn 0.2s ease-out;
  }
  
  /* 移动端汉堡菜单按钮样式 */
  .inline-flex {
    transition: all 0.2s ease-in-out;
  }
  
  .inline-flex:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
}

/* 平板端样式 */
@media (min-width: 768px) and (max-width: 1023px) {
  .space-x-6 > * + * {
    margin-left: 1.5rem;
  }
  
  .text-sm {
    font-size: 0.875rem;
  }
  
  .text-base {
    font-size: 1rem;
  }
}

/* 桌面端样式 */
@media (min-width: 1024px) {
  .space-x-6 > * + * {
    margin-left: 1.5rem;
  }
  
  /* 桌面端悬停效果 */
  .group:hover .absolute {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }
  
  .absolute {
    pointer-events: none;
  }
  
  .absolute[v-show="true"] {
    pointer-events: auto;
  }
}

/* 动画定义 */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 500px;
  }
}

/* 移动端子菜单容器 */
.ml-4 {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
}

.ml-4[v-show="true"] {
  max-height: 500px;
}

/* 移动端菜单滚动支持 */
@media (max-height: 600px) {
  .lg\\:hidden {
    max-height: 80vh;
    overflow-y: auto;
  }
}

/* 移动端选择框样式优化 */
select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
}

/* 移动端按钮触摸优化 */
button {
  -webkit-tap-highlight-color: transparent;
}

/* 移动端链接触摸优化 */
a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
}

/* 高分辨率屏幕优化 */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .shadow-lg {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
}

/* 全局主题样式 */
.theme-light {
  /* 浅色模式样式 */
  --bg-primary: #ffffff;
  --text-primary: #1f2937;
  --text-secondary: #6b7280;
  --border-color: #e5e7eb;
}

.theme-dark {
  /* 深色模式样式 */
  --bg-primary: #1f2937;
  --text-primary: #f9fafb;
  --text-secondary: #d1d5db;
  --border-color: #374151;
}

/* 跟随系统偏好 - theme-system 不需要特殊样式 */

/* 应用主题到整个应用 */
.theme-light body {
  background-color: var(--bg-primary);
  color: var(--text-primary);
}

.theme-dark body {
  background-color: var(--bg-primary);
  color: var(--text-primary);
}

  /* 深色模式支持 */
  @media (prefers-color-scheme: dark) {
    .bg-white {
      background-color: #1f2937;
    }
    
    .text-gray-600 {
      color: #d1d5db;
    }
    
    .text-gray-700 {
      color: #e5e7eb;
    }
    
    .text-gray-800 {
      color: #f9fafb;
    }
    
    .border-gray-200 {
      border-color: #374151;
    }
    
    .bg-purple-50 {
      background-color: rgba(139, 92, 246, 0.1);
    }
    
    /* 按钮悬停状态 */
    .hover\\:text-gray-800:hover {
      color: #f9fafb;
    }
    
    .hover\\:bg-gray-100:hover {
      background-color: #374151;
    }
    
    .hover\\:text-purple-600:hover {
      color: #a855f7;
    }
    
    /* 修复二级菜单悬停背景色 - 覆盖 Tailwind 的浅色背景 */
    .hover\\:bg-purple-50:hover {
      background-color: rgba(139, 92, 246, 0.1);
    }
    
    /* 选择框样式 */
    select {
      background-color: #1f2937;
      border-color: #374151;
      color: #f9fafb;
    }
    
    select:focus {
      border-color: #8b5cf6;
      box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
    }
    
    /* 子菜单样式 */
    .absolute.bg-white {
      background-color: #1f2937;
    }
    
    .absolute.border-gray-200 {
      border-color: #374151;
    }
    
    /* 图标颜色 */
    .text-gray-600 i {
      color: #d1d5db;
    }
    
    .text-purple-600 i {
      color: #a855f7;
    }
    
    /* 移动端菜单背景 */
    .lg\\:hidden.bg-white {
      background-color: #1f2937;
    }
    
    /* 用户头像区域 */
    .border-t.border-gray-200 {
      border-color: #374151;
    }
    
    /* 确保按钮在深色模式下仍然可点击 */
    button, a {
      pointer-events: auto !important;
    }
    
    /* 修复按钮的交互状态 */
    button:not(:disabled):hover,
    a:not(:disabled):hover {
      opacity: 0.8;
    }
    
    button:focus,
    a:focus {
      outline: 2px solid #8b5cf6;
      outline-offset: 2px;
    }
  }
</style>
